import { apiGet, apiPut } from "./http";
import type { ActivityCategory } from "../pages/admin/utils/activityCategoryStore";

export interface ActivityCategoryDto {
  categoryKey: string;
  name: string;
  icon: string;
  enabled: boolean;
  description: string;
  sortOrder: number;
}

export function dtoToActivityCategory(d: ActivityCategoryDto): ActivityCategory {
  return {
    id: d.categoryKey,
    name: d.name,
    icon: d.icon,
    enabled: d.enabled,
    description: d.description ?? "",
  };
}

export function activityCategoriesToReplaceBody(items: ActivityCategory[]) {
  return {
    categories: items.map((c, i) => ({
      categoryKey: c.id,
      name: c.name,
      icon: c.icon,
      enabled: c.enabled !== false,
      description: c.description ?? "",
      sortOrder: i + 1,
    })),
  };
}

export async function fetchActivityCategoriesForTenant(tenantLegacyId: string): Promise<ActivityCategory[]> {
  const rows = await apiGet<ActivityCategoryDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/activity-categories`,
  );
  return rows.map(dtoToActivityCategory);
}

export async function putActivityCategoriesForTenant(
  tenantLegacyId: string,
  items: ActivityCategory[],
): Promise<ActivityCategory[]> {
  const rows = await apiPut<ActivityCategoryDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/activity-categories`,
    activityCategoriesToReplaceBody(items),
  );
  return rows.map(dtoToActivityCategory);
}
